import useFullPageLoader from 'common/UseFullPageLoader';
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { getMasterListApi } from 'services/masterApi';
import { coinTabs } from 'utils/componentValue/MasterValue';
import AwardCoins from './section/AwardCoins';
import SetCoinValue from './section/SetCoinValue';

const CoinManagement = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const position = searchParams.get("position") || 'SETCOINVALUE';
    const [coinsList, setCoinsList] = useState([])

    // -------handle-tab-change------------------
    const handleTabChange = (tabValue) => {
        const newParams = new URLSearchParams(searchParams.toString());
        newParams.set("position", tabValue);
        setSearchParams(newParams);
    };

    // ---------get-list---------------
    const getCoinsList = async () => {
        try {
            onShow();
            setCoinsList([])
            const res = await getMasterListApi({ type: position });
            const { code, data } = res?.data;
            if (code === 200) {
                setCoinsList(data);
            }
        } catch (error) {
            console.log("BAnner Data fetch error:---> ", error);
        } finally {
            onHide();
        }
    };

    useEffect(() => {
        getCoinsList()
    }, [position])

    return (
        <div className="banner-management-parent">
            {loader}
            <div className="page_title">
                <h3>Manage Coins</h3>
            </div>
            <div className="card">
                <div className="tabContainer">
                    <ul>
                        {coinTabs.map((tabData) => (
                            <li
                                key={tabData.id}
                                className={tabData.value === position ? "active" : "un-active"}
                                onClick={() => handleTabChange(tabData.value)}
                            >
                                {tabData.name}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* ---------delivery-slot---------- */}
                {position === 'SETCOINVALUE' && <SetCoinValue {...{ coinsList, setCoinsList, onHide, getCoinsList }} />}
                {/* ---------award-coins---------- */}
                {position === 'AWARDCOINS' && <AwardCoins {...{ coinsList, setCoinsList, onHide, getCoinsList }} />}

            </div>
        </div>
    )
}

export default CoinManagement